import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useForm from 'react-hook-form';
/* actions */
import { getAllDepartments } from '../../redux/actions/departments';
import { addNetworksGroup } from '../../redux/actions/networksGroup';
import { getAllDevices } from '../../redux/actions/devices';
/* components */
import ErrorMsgField from '../../components/ErrorMsgField';
import AlertMsg from '../../components/AlertMsg';
import FormFooter from '../../components/FormFooter';
import FormHeader from '../../components/FormHeader';
import MultiSelect from '../../components/MultiSelect';
/* form-validation */
import schema from '../../form-validation/networksGroup';
/* utils */
import sortable from '../../utils/sortable';
import {
  handleMultiSelect,
  handleMultiDeselect
} from '../../utils/multiSelect';
import handleChangeDefault from '../../utils/handleChangeDefault';

function Add () {
  const INITIAL_VALUES = {
    name: '',
    department: '',
    description: '',
    devices: []
  };
  const dispatch = useDispatch();
  const submitButton = useRef();
  const { register, handleSubmit, errors, reset } = useForm({
    validationSchema: schema,
    reValidateMode: 'onSubmit'
  });
  const departments = useSelector(state => state.departments);
  const devices = useSelector(state => state.devices.data);
  const networksGroup = useSelector(state => state.networksGroup);
  const [data, setData] = useState(INITIAL_VALUES);
  const [selectedOptions, setSelectedOptions] = useState({ devices: [] });
  const [networks, setNetworks] = useState([]);

  useEffect(() => {
    dispatch(getAllDepartments());
    dispatch(getAllDevices());
  }, [dispatch]);

  useEffect(() => {
    if (devices.length) {
      const networks = devices
        .filter(device => device.type === 'N')
        .map(device => ({
          value: device._id,
          text: `N${device.number}`,
          sortValue: `N${device.number}`
        }))
        .sort(sortable);

      setNetworks([...networks]);
    }
  }, [devices, setNetworks]);

  const submit = () => {
    const resetForm = () => {
      reset();
      setData({ ...INITIAL_VALUES });
      Object.keys(selectedOptions).forEach(key =>
        setSelectedOptions({ ...selectedOptions, [key]: [] })
      );
    };
    dispatch(addNetworksGroup(data, resetForm, submitButton.current));
  };

  return (
    <div className="container-fluid">
      {networksGroup.addSuccess && (
        <AlertMsg type="success" msg="Grupo de tronco cadastrado com sucesso" />
      )}
      {networksGroup.errorContent &&
        !networksGroup.errorContent.message.includes('400') &&
        networksGroup.addError && (
        <AlertMsg
          type="danger"
          msg="Falha durante cadastro do grupo de tronco"
        />
      )}
      {networksGroup.errorContent &&
        networksGroup.errorContent.message.includes('400') &&
        networksGroup.addError && (
        <AlertMsg
          type="danger"
          msg="Um grupo com o nome informado já está cadastrado"
        />
      )}
      {!networksGroup.addSuccess && !networksGroup.addError && (
        <AlertMsg type="info" msg="Área cadastro do grupo de tronco" />
      )}
      <FormHeader title="Cadastrar Grupo de Tronco" />
      <form onSubmit={handleSubmit(submit)}>
        <div className="form-group">
          <label htmlFor="name">
            Nome<span className="field-required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="name"
            autoComplete="off"
            value={data.name}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          />
          {errors.name && errors.name.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="department">
            Departamento<span className="field-required">*</span>
          </label>
          <select
            className="form-control"
            id="department"
            name="department"
            value={data.department}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          >
            <option value="">-- Selecione --</option>
            {departments.data.map((dpt, i) => {
              const _id = dpt._id || Date.now() + '' + i;
              return (
                <option key={_id} value={_id}>
                  {dpt.name}
                </option>
              );
            })}
          </select>
          {errors.department && errors.department.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="description">
            Descrição<span className="field-required">*</span>
          </label>
          <textarea
            className="form-control"
            id="description"
            name="description"
            rows="3"
            value={data.description}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          ></textarea>
          {errors.description && errors.description.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <MultiSelect
          avaliableOptions={networks}
          selectedOptions={selectedOptions.devices}
          handleMultiDeselect={options =>
            handleMultiDeselect(
              options,
              'devices',
              selectedOptions,
              setSelectedOptions,
              data,
              setData
            )
          }
          handleMultiSelect={options =>
            handleMultiSelect(
              options,
              'devices',
              selectedOptions,
              setSelectedOptions,
              data,
              setData
            )
          }
          valueProp="value"
          textProp="text"
          title="Troncos"
          fieldRequired={true}
          name="devices"
          ref={register}
          error={!!errors.devices}
        />
        <FormFooter url="/networks_group" reference={submitButton} />
      </form>
    </div>
  );
}

export default Add;
